import { useDonationsSummaryContext } from "../hooks/useDonationSummaryContext"
import { DonationHistoryProvider } from "../hooks/useDonationHistoryContext"

export function DonationHistoryInitializer({
  children,
}: {
  children: React.ReactNode
}) {
  const { donationsSummary } = useDonationsSummaryContext()
  const defaultYear =
    donationsSummary.all_donation_years[0] || new Date().getFullYear()

  return (
    <DonationHistoryProvider defaultYear={defaultYear}>
      {children}
    </DonationHistoryProvider>
  )
}
